import * as React from 'react';

import { Typography } from '@/app/components/ui/Typography';
import { cn } from '@/utils/ui';

const ShadCard = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn(
      'flex flex-col gap-5 rounded bg-white p-4 py-5 text-gray shadow-sm tablet:p-6 tablet:py-6',
      className,
    )}
    {...props}
  />
));
ShadCard.displayName = 'ShadCard';

const CardHeader = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('flex flex-col gap-3', className)} {...props} />
));
CardHeader.displayName = 'CardHeader';

const CardTitle = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLHeadingElement>
>(({ className, children }, ref) => (
  <Typography
    as="h5"
    color="helsinki-blue"
    ref={ref}
    className={cn('desktop:text-2xl desktop:leading-[38px]', className)}
  >
    {children}
  </Typography>
));
CardTitle.displayName = 'CardTitle';

const CardDescription = React.forwardRef<
  HTMLParagraphElement,
  React.HTMLAttributes<HTMLParagraphElement>
>(({ className, children }, ref) => (
  <Typography
    as="p"
    responsiveSize="bodyLarge"
    ref={ref}
    className={className}
    weight="extraLight"
  >
    {children}
  </Typography>
));
CardDescription.displayName = 'CardDescription';

const CardContent = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div ref={ref} className={cn('flex flex-col gap-5', className)} {...props} />
));
CardContent.displayName = 'CardContent';

const CardFooter = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, ...props }, ref) => (
  <div
    ref={ref}
    className={cn('flex items-center p-6 pt-0', className)}
    {...props}
  />
));
CardFooter.displayName = 'CardFooter';

export {
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
  ShadCard,
};
